import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import { get, map, isEmpty, size } from 'lodash';
import cn from 'classnames';
import { Classes, Tag, Intent } from '@blueprintjs/core';
import { branch, renderNothing } from 'recompose';

const StyledTag = glamorous(Tag)({});

const VXFilterValue = ({ value, onRemove }) => (
  <StyledTag
    css={{ marginRight: 5, marginBottom: 2 }}
    intent={Intent.PRIMARY}
    className={cn(Classes.MINIMAL, Classes.TAG_REMOVABLE)}
  >
    {value.label}
    <button className={Classes.TAG_REMOVE} onClick={e => onRemove(value)}/>
  </StyledTag>
);

const VXCurrentFilter = ({ item, isRemovable, onRemove }) => {
  return (
    <glamorous.Div marginBottom={5}>
      <StyledTag
        className={cn(Classes.MINIMAL, { [Classes.TAG_REMOVABLE]: isRemovable })}
        css={{
          marginRight: 5,
          [`.${Classes.TAG}.${Classes.MINIMAL}`]: {
            background: 'none',
          },
        }}
      >
        {item.label}:{' '}
        {isRemovable && <button className={Classes.TAG_REMOVE} onClick={e => onRemove(item.id, item.values)}/>}
      </StyledTag>
      {map(item.values, v => (
        <VXFilterValue
          key={`${item.id}-${v.id}`}
          value={v}
          onRemove={val => onRemove(item.id, [val])}
        />
      ))}
    </glamorous.Div>
  )
};

const CurrentFilters = ({ filters, translations, onRemoveValues, onRemoveAll }) => (
  <glamorous.Div>
    {map(filters, f => (
      <VXCurrentFilter
        item={f}
        key={f.id}
        isRemovable={false}
        onRemove={onRemoveValues}
      />
    ))}
    <VXCurrentFilter
      isRemovable
      onRemove={() => onRemoveAll()}
      item={{ label: get(translations, 'clearAllLabel') }}
    />
  </glamorous.Div>
);

const withHide = branch(({ hideWhenNoFilters, filters }) => hideWhenNoFilters && isEmpty(filters), renderNothing);
export const VXCurrentFilters = withHide(CurrentFilters);

VXCurrentFilters.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    values: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    })),
  })),
  translations: PropTypes.shape({
    clearAllLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  }),
  onRemoveValues: PropTypes.func,
  onRemoveAll: PropTypes.func,
  hideWhenNoFilters: PropTypes.bool,
};

VXCurrentFilters.defaultProps = {
  filters: [],
  hideWhenNoFilters: true,
  translations: {
    clearAllLabel: 'Clear all filters',
  },
  onRemoveValues: () => {
  },
  onRemoveAll: () => {
  },
};



// WEBPACK FOOTER //
// ./src/views/visions/vx-current-filters.js